import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { OptimizedImage } from "./OptimizedImage.tsx";

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.logoSection}>
          <Link to="/" className={styles.logo}>
            <OptimizedImage
              src="/vajra_logo.webp"
              alt="Vajra Martial Arts Academy Logo"
              width={36}
              height={36}
              loading="lazy"
              style={{ borderRadius: '50%', objectFit: 'cover' }}
            />
            <h2>Vajra Martial Arts</h2>
          </Link>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} Vajra Martial Arts Academy. All Rights
            Reserved.
          </p>
        </div>
        <div className={styles.socials}>
          <a
            href="https://www.facebook.com/vajra.mix.ma/"
            aria-label="Facebook"
            className={styles.socialLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Facebook size={20} />
          </a>
          <a
            href="https://www.instagram.com/vajra_martialarts_academy/"
            aria-label="Instagram"
            title="Instagram"
            className={styles.socialLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram size={20} />
          </a>
          <a
            href="https://www.instagram.com/vajra_martialartsacademy2.0/"
            aria-label="Instagram — Mohali"
            title="Instagram — Mohali"
            className={styles.socialLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram size={20} />
          </a>
          <a
            href="https://www.instagram.com/vajra.martialarts.academy3.0/"
            aria-label="Instagram — Indirapuram"
            title="Instagram — Indirapuram"
            className={styles.socialLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram size={20} />
          </a>
          <a
            href="https://www.youtube.com/@vajramartialartsacademy7867"
            aria-label="YouTube"
            className={styles.socialLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Youtube size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
};